import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento-medico`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create: (id) => {
            return repository.get(`${baseUrl}/${id}/create`)
        },
        getMedicosAtendimento: (atendimentoId) => {
            return repository.get(`${baseUrl}/medico-atendimento/${atendimentoId}`)
        },
        getProfissionaisAtendimento: (atendimentoId) => {
            return repository.get(`${baseUrl}/profissional-atendimento/${atendimentoId}`)
        },
        getDeclaracoesComparecimento: (atendimentoId) => {
            return repository.get(`${baseUrl}/declaracao-comparecimento/${atendimentoId}`)
        },
        store: (params) => {
            return repository.post(`${baseUrl}`, params)
        },
        storeDeclaracaoComparecimento: (params) => {
            return repository.post(`${baseUrl}/declaracao-comparecimento`, params)
        },
        storeFaaAssinada: (id, params) => {
            return repository.post(`${baseUrl}/${id}/store-faa-assinada`, params)
        },
        storeReceitasAssinadas: (id, params) => {
            return repository.post(`${baseUrl}/${id}/store-receita-assinada`, params)
        },
        download: (route) => {
            return repository.get(route, { responseType: "arraybuffer" })
        },
    }
}